const _excluded = ["onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Controller } from 'react-hook-form';
import { Card, MenuItem, Select, Typography } from 'seagull';
import { getAllowManualPaymentsChangeBullet, getAmendmentsApprovalMethodChangeBullet, getCoverCCFeesChangeBullet, getInvoicesApprovalMethodChangeBullet, getNetTermsChangeBullet, netTermsSelectOptions } from "../../business-logic/amendmentsLogic";
import { getAutoApprovalRange } from "../../business-logic/autoApprovalLogic";
import { approvalMethodNoticePeriodModel, relationshipModel } from "../../models";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { AllowManualPaymentsCheckbox, ApprovalMethodNoticePeriodField, CoverCreditCardFeesSelector, validateApprovalMethodNoticePeriod } from "../agreement-controllers";
import AmendmentChanges from "../AmendmentChanges/AmendmentChanges";
import styles from "./EditAgreementModal.module.scss";
import { useEditAgreementForm } from "./utils/EditAgreementModal.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Section = props => /*#__PURE__*/_jsx(Card, {
  autoHeight: true,
  padding: "m",
  title: props.title,
  children: /*#__PURE__*/_jsx("div", {
    className: styles.sectionContent,
    children: props.children
  })
});
export const SettingsField = props => /*#__PURE__*/_jsx("div", {
  className: styles.settingsField,
  children: props.children
});
export function EditNetTerms(props) {
  const {
    relationship
  } = props;
  const {
    watch,
    control
  } = useEditAgreementForm();
  const updatedNetTerms = watch('updatedNetTerms');
  const netTermsChangeBullet = getNetTermsChangeBullet(relationship, updatedNetTerms);
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "updatedNetTerms",
    render: p => {
      const _connectControllerToT = connectControllerToTextField(p),
        {
          onChange: _onChange
        } = _connectControllerToT,
        rest = _objectWithoutProperties(_connectControllerToT, _excluded);
      return /*#__PURE__*/_jsxs(SettingsField, {
        children: [/*#__PURE__*/_jsx(Typography, {
          children: "Set the number of days the payment is due after the invoice date"
        }), /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
          collapseHelperText: false,
          menuMaxHeight: 200,
          width: 280,
          testId: "edit-net-terms",
          onChange: e => _onChange(+e.target.value)
        }, rest), {}, {
          children: netTermsSelectOptions.map(_ref => {
            let {
              value,
              text
            } = _ref;
            return /*#__PURE__*/_jsx(MenuItem, {
              value: value.toString(),
              testId: "net-terms-opt-".concat(value),
              children: text
            }, value);
          })
        })), netTermsChangeBullet && /*#__PURE__*/_jsx(AmendmentChanges, {
          disableNote: true,
          disableBorderRadius: true,
          items: [netTermsChangeBullet],
          isUnsaved: p.fieldState.isDirty,
          testId: "net-terms-changes",
          autoApprovalDate: relationshipModel.updatedNetTermsAutoApprovalDate(relationship),
          onDiscard: () => _onChange(relationship.netTerms)
        })]
      });
    }
  });
}
export function EditCCFees(props) {
  const {
    relationship
  } = props;
  const {
    control,
    watch
  } = useEditAgreementForm();
  const coverCreditCardFees = watch('coverCreditCardFees');
  const changeBullet = getCoverCCFeesChangeBullet(relationship, coverCreditCardFees);
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "coverCreditCardFees",
    render: _ref2 => {
      let {
        field: {
          value,
          onChange
        },
        fieldState: {
          isDirty
        }
      } = _ref2;
      return /*#__PURE__*/_jsxs(SettingsField, {
        children: [/*#__PURE__*/_jsx(CoverCreditCardFeesSelector, {
          testId: "cc-fees",
          vendorBusinessName: relationshipModel.vendorName(relationship),
          clientBusinessName: relationshipModel.customerName(relationship),
          value: value,
          onChange: onChange
        }), changeBullet && /*#__PURE__*/_jsx(AmendmentChanges, {
          disableNote: true,
          disableBorderRadius: true,
          items: [changeBullet],
          isUnsaved: isDirty,
          testId: "cc-fees-changes",
          autoApprovalDate: relationshipModel.updatedIsVendorCoveringCCFeeAutoApprovalDate(relationship),
          onDiscard: () => onChange(relationshipModel.isVendorCoveringCCFee(relationship))
        })]
      });
    }
  });
}
const EditApprovalMethodNoticePeriod = _ref3 => {
  let {
    info,
    text,
    testId,
    fieldName,
    relationship,
    autoApprovalDate,
    getApprovalMethodChangeBullet
  } = _ref3;
  const {
    control,
    watch
  } = useEditAgreementForm();
  const approvalMethod = watch(fieldName);
  const noticePeriodDays = approvalMethodNoticePeriodModel.noticePeriodDays(approvalMethod);
  const changeBullet = getApprovalMethodChangeBullet(relationship[fieldName], approvalMethod);
  return /*#__PURE__*/_jsx(Controller, {
    name: fieldName,
    control: control,
    rules: {
      validate: value => validateApprovalMethodNoticePeriod(approvalMethodNoticePeriodModel.isAutoApproval(value), approvalMethodNoticePeriodModel.noticePeriodDays(value) || '')
    },
    render: _ref4 => {
      let {
        field: {
          value,
          onChange
        },
        fieldState: {
          isDirty
        }
      } = _ref4;
      return /*#__PURE__*/_jsxs(SettingsField, {
        children: [/*#__PURE__*/_jsx(ApprovalMethodNoticePeriodField, {
          testId: testId,
          info: info,
          text: text,
          enabled: approvalMethodNoticePeriodModel.isAutoApproval(value),
          noticePeriod: noticePeriodDays != null ? noticePeriodDays : '',
          onToggle: enabled => {
            if (enabled) {
              const {
                maxDays
              } = getAutoApprovalRange();
              onChange(approvalMethodNoticePeriodModel.makeAutoApprovalMethodNoticePeriod(maxDays));
            } else {
              onChange(approvalMethodNoticePeriodModel.makeManualApprovalMethodNoticePeriod());
            }
          },
          onChangePeriod: noticePeriod => {
            if (noticePeriod === '') return;
            onChange(approvalMethodNoticePeriodModel.makeAutoApprovalMethodNoticePeriod(noticePeriod));
          }
        }), changeBullet && /*#__PURE__*/_jsx(AmendmentChanges, {
          disableNote: true,
          disableBorderRadius: true,
          items: [changeBullet],
          isUnsaved: isDirty,
          testId: "".concat(testId, "-changes"),
          autoApprovalDate: autoApprovalDate,
          onDiscard: () => onChange(relationship[fieldName])
        })]
      });
    }
  });
};
export const EditAmendmentsApprovalMethod = _ref5 => {
  let {
    relationship
  } = _ref5;
  return /*#__PURE__*/_jsx(EditApprovalMethodNoticePeriod, {
    info: "Amendments will take effect automatically if the client doesn't disable within the notice period set. Amended invoices issued during the notice period will require client approval.",
    text: 'Automatically approve amendments after a defined period',
    testId: 'amendments-approval-method',
    fieldName: 'amendmentsApprovalMethod',
    relationship: relationship,
    autoApprovalDate: relationshipModel.updatedAmendmentsApprovalMethodAutoApprovalDate(relationship),
    getApprovalMethodChangeBullet: getAmendmentsApprovalMethodChangeBullet
  });
};
export const EditInvoicesApprovalMethod = _ref6 => {
  let {
    relationship
  } = _ref6;
  return /*#__PURE__*/_jsx(EditApprovalMethodNoticePeriod, {
    info: "Invoices that require client approval will be approved automatically if the client doesn't disable within the notice period set.",
    text: "Automatically approve out-of-scope charges after a defined period",
    testId: 'invoices-approval-method',
    fieldName: 'invoicesApprovalMethod',
    relationship: relationship,
    autoApprovalDate: relationshipModel.updatedInvoicesApprovalMethodAutoApprovalDate(relationship),
    getApprovalMethodChangeBullet: getInvoicesApprovalMethodChangeBullet
  });
};
export function EditAllowManualPayments(props) {
  const {
    relationship
  } = props;
  const {
    control,
    watch
  } = useEditAgreementForm();
  const allowManualPayments = watch('allowManualPayments');
  const changeBullet = getAllowManualPaymentsChangeBullet(relationship, allowManualPayments);
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "allowManualPayments",
    render: _ref7 => {
      let {
        field: {
          value,
          onChange: _onChange2
        },
        fieldState: {
          isDirty
        }
      } = _ref7;
      return /*#__PURE__*/_jsxs(SettingsField, {
        children: [/*#__PURE__*/_jsx(AllowManualPaymentsCheckbox, {
          value: value,
          onChange: newValue => _onChange2(newValue)
        }), changeBullet && /*#__PURE__*/_jsx(AmendmentChanges, {
          disableNote: true,
          disableBorderRadius: true,
          items: [changeBullet],
          isUnsaved: isDirty,
          testId: "allow-manual-payments-changes",
          autoApprovalDate: relationshipModel.updatedAllowManualPaymentsAutoApprovalDate(relationship),
          onDiscard: () => _onChange2(relationship.allowManualPayments)
        })]
      });
    }
  });
}